module.exports = __webpack_public_path__ + "img/wind_light.8215373d.svg";